import React, { useState } from 'react';
import { Instagram, Twitter, Facebook } from 'lucide-react';
export function LandingPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) setSubmitted(true);
  };
  return <div className="min-h-screen bg-[#FFF8F0] flex flex-col items-center justify-center relative overflow-hidden px-4" data-id="element-222">
      {/* Background decorative circles */}
      <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-orange-100 opacity-60 blur-3xl pointer-events-none" data-id="element-223" />
      <div className="absolute -bottom-40 -left-40 w-[600px] h-[600px] rounded-full bg-amber-100 opacity-50 blur-3xl pointer-events-none" data-id="element-224" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-orange-50 opacity-40 blur-3xl pointer-events-none" data-id="element-225" />

      {/* Spice dot pattern top-left */}
      <div className="absolute top-12 left-12 flex gap-2 opacity-30 pointer-events-none" data-id="element-226">
        {[...Array(5)].map((_, i) => <div key={i} className="flex flex-col gap-2" data-id="element-227">
            {[...Array(5)].map((_, j) => <div key={j} className="w-1.5 h-1.5 rounded-full bg-orange-400" data-id="element-228" />)}
          </div>)}
      </div>

      {/* Spice dot pattern bottom-right */}
      <div className="absolute bottom-12 right-12 flex gap-2 opacity-30 pointer-events-none" data-id="element-229">
        {[...Array(5)].map((_, i) => <div key={i} className="flex flex-col gap-2" data-id="element-230">
            {[...Array(5)].map((_, j) => <div key={j} className="w-1.5 h-1.5 rounded-full bg-green-500" data-id="element-231" />)}
          </div>)}
      </div>

      {/* Main content */}
      <div className="relative z-10 flex flex-col items-center text-center max-w-2xl mx-auto" data-id="element-232">
        {/* Logo */}
        <div className="flex items-center gap-3 mb-12" data-id="element-233">
          <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl flex items-center justify-center text-white font-bold text-2xl shadow-lg shadow-orange-200" data-id="element-234">
            H
          </div>
          <span className="text-3xl font-bold text-slate-900" style={{
          fontFamily: "'Poppins', sans-serif"
        }} data-id="element-235">
            Hypercart
          </span>
        </div>

        {/* Coming Soon badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-orange-100 text-orange-700 text-sm font-semibold mb-8 tracking-wide uppercase" data-id="element-236">
          <span className="relative flex h-2 w-2" data-id="element-237">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-orange-400 opacity-75" data-id="element-238" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-orange-500" data-id="element-239" />
          </span>
          Coming Soon
        </div>

        {/* Headline */}
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold text-slate-900 leading-[1.05] mb-6" style={{
        fontFamily: "'Poppins', sans-serif"
      }} data-id="element-240">
          All Indian Grocery,{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 via-red-500 to-orange-600" data-id="element-241">
            One Stop Shop
          </span>
        </h1>

        {/* Subtext */}
        <p className="text-lg sm:text-xl text-slate-500 leading-relaxed mb-12 max-w-lg" data-id="element-242">
          From basmati to biryani masala, paneer to papad — everything you love,
          delivered fresh to your door. We're putting the finishing touches on
          something special.
        </p>

        {/* Email notify form */}
        {!submitted ? <form onSubmit={handleSubmit} className="w-full max-w-md flex items-center bg-white rounded-2xl shadow-md shadow-orange-100 border border-orange-100 overflow-hidden p-1.5" data-id="element-243">
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Enter your email to get notified" className="flex-1 px-4 py-3 text-slate-700 placeholder:text-slate-400 bg-transparent outline-none text-sm" required data-id="element-244" />
            <button type="submit" className="flex-shrink-0 bg-gradient-to-r from-orange-500 to-red-500 text-white text-sm font-semibold px-5 py-3 rounded-xl hover:from-orange-600 hover:to-red-600 transition-all" data-id="element-245">
              Notify Me
            </button>
          </form> : <div className="w-full max-w-md flex items-center justify-center gap-3 bg-green-50 border border-green-200 rounded-2xl px-6 py-4" data-id="element-246">
            <div className="w-6 h-6 rounded-full bg-green-500 flex items-center justify-center text-white text-xs font-bold" data-id="element-247">
              ✓
            </div>
            <p className="text-green-700 font-medium text-sm" data-id="element-248">
              You're on the list! We'll notify you when we launch.
            </p>
          </div>}

        {/* Spice emojis row */}
        <div className="flex items-center gap-4 mt-12 text-3xl opacity-70" data-id="element-249">
          
          <span className="w-1 h-1 rounded-full bg-slate-300" data-id="element-250" />
          
          <span className="w-1 h-1 rounded-full bg-slate-300" data-id="element-251" />
          
          <span className="w-1 h-1 rounded-full bg-slate-300" data-id="element-252" />
          
          <span className="w-1 h-1 rounded-full bg-slate-300" data-id="element-253" />
          
          <span className="w-1 h-1 rounded-full bg-slate-300" data-id="element-254" />
          
        </div>
      </div>

      {/* Footer */}
      <div className="absolute bottom-8 left-0 right-0 flex flex-col items-center gap-4 px-4" data-id="element-255">
        <div className="flex items-center gap-5" data-id="element-256">
          <a href="#" className="text-slate-400 hover:text-orange-500 transition-colors" data-id="element-257">
            <Instagram className="h-5 w-5" data-id="element-258" />
          </a>
          <a href="#" className="text-slate-400 hover:text-orange-500 transition-colors" data-id="element-259">
            <Twitter className="h-5 w-5" data-id="element-260" />
          </a>
          <a href="#" className="text-slate-400 hover:text-orange-500 transition-colors" data-id="element-261">
            <Facebook className="h-5 w-5" data-id="element-262" />
          </a>
        </div>
        <p className="text-slate-400 text-xs" data-id="element-263">
          © {new Date().getFullYear()} Hypercart · Made with ❤️ for the Indian
          community
        </p>
      </div>
    </div>;
}